import { QueryClient } from "@tanstack/react-query";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";

export const invalidateEmailLogsAfterDelay = (
  queryClient: QueryClient,
  delayMs: number
) => {
  setTimeout(() => {
    queryClient.invalidateQueries({
      queryKey: [endpointsMetadata.communicationLogs.getEmailLogs],
    });
  }, delayMs);
};
